<template>
  <div id="header_content" class="header_content">
    <Banner bys="swipe"></Banner>
    <h1 class="hct"><a href="/xy_web/" class="logo"><img src="../assets/logo_white.png" alt=""></a></h1>
    <nav class="nav_btn"><a href="./project_list.html">作品</a> <a href="./news.html">新闻</a><a href="./job.html">加入团队</a></nav>
    <div :class="[mlw?'mwf':'mwa', 'menu_wrapper']">
      <Menu :imgbool="[mlw?1:0]"></Menu>
    </div>
  </div>
</template>

<script>
  import Banner from "./common/Banner.vue";
  import Menu from "./common/Menu.vue";
  export default {
    name: "HeaderHome",
    components: {
      Banner,
      Menu
    },
    data: function() {
      return {
        mlw: false
      }
    },
    methods: {
      menuStyle: function(value) {
        this.mlw = value;
      }
    },
    mounted: function() {
      console.log(this.mlw);
    },
    destroyed() {

    }
  }
</script>

<style type="text/less" lang="less">
  .header_content {
    .hct {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 80%;
      position: absolute;
      z-index: 10;
      top: 3.203vw;
      left: 9.796vw;

      .logo {
        img {
          height: 1.257vw;
        }
      }
    }

    .nav_btn {
      width: 95vw;
      height: 100%;
      position: absolute;
      z-index: 3;
      top: 0;
      left: 2.5vw;
      display: flex;
      justify-content: center;
      align-items: center;

      a {
        font-family: "SSHei";
        font-size: 2em;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 8.16em;
        height: 8.16em;
        border: solid 3px white;
        border-radius: 5em;
        margin: 0 1.535em;
        transition: color 0.2s ease, background-color 0.2s ease;

        &:hover {
          color: #000;
          background-color: white;
        }
      }
    }

    @import url("../assets/css/menu.less");

  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderHome.vue